import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=f3a667ee&"
import script from "./charge.vue?vue&type=script&lang=js&"
export * from "./charge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3a667ee')) {
      api.createRecord('f3a667ee', component.options)
    } else {
      api.reload('f3a667ee', component.options)
    }
    module.hot.accept("./charge.vue?vue&type=template&id=f3a667ee&", function () {
      api.rerender('f3a667ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/houseDeliveryManage/decorationRegistration/charge.vue"
export default component.exports